import { render, staticRenderFns } from "./newsSort.vue?vue&type=template&id=35b86546&scoped=true"
import script from "./newsSort.vue?vue&type=script&lang=js"
export * from "./newsSort.vue?vue&type=script&lang=js"
import style0 from "./newsSort.vue?vue&type=style&index=0&id=35b86546&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b86546",
  null
  
)

export default component.exports